<template>
  <div>
    <!-- Directly load the vragenlijst-component custom element -->
    <vragenlijst-component />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* Add any global styles here if needed */
</style>
